<div class="popup">
    <div class="section">
        <div class="header">
            <div class="label">
               Add Received Quantity
            </div>
            <div class="close">
                <button mat-icon-button class="close-button" [mat-dialog-close]="true">
                    <img src="assets/popup_close_icon.svg" alt="">
                </button>
            </div>
        </div>
        <div class="body">
            <div class="table">
                <div class="tableHeader">
                    <div class="table_header_left">
                        <div class="label">
                            Invoices
                        </div>
                        <div class="did-floating-label-content">
                            <input type="number" class="input_field did-floating-input" placeholder=" " [(ngModel)]="mwg">
                            <label class="did-floating-label">Enter MWG</label>
                            <div class="weight_measure">
                                <div class="box">MT</div>
                            </div>
                         </div>
                    </div>
                    
                    <div style=" display: flex; flex-direction: column; padding-bottom: 16px; gap: 8px;">
                        <div>
                            TW Weight : <span style="font-weight: 400;    border-bottom: solid;"> {{twWeigth}} (MT)</span>
                           </div>
                           <div>
                            GW Weight : <span style="font-weight: 400;    border-bottom: solid;"> {{gwWeigth}} (MT)</span>
                           </div>
                       </div>
                </div>
                <div class="tableBody">
                    <table mat-table [dataSource]="dataSource">

                        <!-- Sno Column -->
                        <ng-container matColumnDef="sno">
                            <th mat-header-cell *matHeaderCellDef>Sno</th>
                            <td mat-cell *matCellDef="let element">{{element.sno}}</td>
                        </ng-container>

                        <!-- Trip Id column -->
                        <ng-container matColumnDef="sin">
                            <th mat-header-cell *matHeaderCellDef>SIN</th>
                            <td mat-cell *matCellDef="let element">{{element.sin}}</td>
                        </ng-container>

                        <!-- Invoice Column -->
                        <ng-container matColumnDef="invoice">
                            <th mat-header-cell *matHeaderCellDef>Invoice / DO</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="cancel" style="display: flex; align-items: center; justify-content: space-between;">
                                    <div class="data">
                                        {{element.invoice}}  <br>
                                        {{ element.do || 'N/A'}}
                                    </div>
                                    <div class="icon" >
                                        <img style="width: 16px; position: relative; top: 3px; cursor: pointer; padding-left: 5px;" (click)="$event.stopPropagation(); cancelInvoice(element._id)" src="assets/icon-cancel-red.svg" alt="" class="icon" /> 
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Final Freight Column-->
                        <ng-container matColumnDef="finalFreightRate">
                            <th mat-header-cell *matHeaderCellDef>Freight Rate (₹)<br> Invoice Type</th>
                            <td mat-cell *matCellDef="let element">
                            <div style="display: flex; align-items: center;">
                                <div><input style="border: none; padding-left:0px; width:60px; align-items: left;" [(ngModel)]="element.finalFreightRate" /><br>
                                    {{element.invoiceType}}</div>
                                <div *ngIf="element.invoiceType==='CT' || element.invoiceType==='-';" (click)="handleGetFreight(element,index)">
                                    <img style="width: 24px; height: 24px; position: relative; top: 3px; cursor: pointer; padding-left:2px; align-items:center;" src="assets/download_frieght_rate_icon.svg" alt=""/> 
                                </div>
                                </div>
                            </td>
                        </ng-container>

                    
                        <!-- OD number Column -->
                        <ng-container matColumnDef="shippedQty">
                            <th mat-header-cell *matHeaderCellDef>Shipped Quantity (MT)</th>
                            <td mat-cell *matCellDef="let element" (click)="element.receivedQty = element.shippedQty">{{element.shippedQty}}</td>
                        </ng-container>

                        <!-- chargeWeight Column -->
                        <ng-container matColumnDef="shippedNop">
                            <th mat-header-cell *matHeaderCellDef>Shipped No of pieces</th>
                            <td mat-cell *matCellDef="let element" (click)="element.receivedNop = element.shippedNop">{{element.shippedNop}}</td>
                        </ng-container>
                        
                        <ng-container matColumnDef="receivedQty">
                            <th mat-header-cell *matHeaderCellDef>Received Quantity (MT)</th>
                            <td mat-cell *matCellDef="let element">
                                <input type="number" [(ngModel)]="element.receivedQty" >
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="receivedNop">
                            <th mat-header-cell *matHeaderCellDef>Received No of pieces</th>
                            <td mat-cell *matCellDef="let element">
                                <input type="number" [(ngModel)]="element.receivedNop">
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="epods">
                            <th mat-header-cell *matHeaderCellDef>ePOD</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="epods">
                                    <div class="count" (click)="downloadEpods(element.epods)" title="Download ePOD">{{element.epods.length}}
                                    </div>
                                    <div class="upload" (click)="openFileUploader(element)" title="Upload ePOD">
                                        <mat-icon class="more-icon">upload_file</mat-icon>
                                    </div>
                                </div>
                        
                            </td>
                        </ng-container>

                        <!-- Define table columns -->
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>

            </div>
            <div class="details" style="margin: 0;
    height: 90px;
    background: #fff2e0;
    width: 592px;
    font-size: 10px;
    font-weight: 500;
    align-items: center;
    color: #ef6b05;
    padding: 0 12px;
    border-radius: 6px;">
    <p style="font-weight: 600;">Note</p>
                <p style="padding-left: 30px;">Click on this icon <img style="width: 16px; height: 16px; position: relative; top: 3px; padding-left:2px; align-items:center;" src="assets/download_frieght_rate_icon.svg" alt=""/> to fetch the data for any mismatch in Freight Rate.</p>
                <p style="padding-left: 30px;">Utilize the "Missed Events" option within the "Action" menu for any mismatch in TW/GW weights.
                    </p>
            </div>
            <div class="buttons">
                <div class="newButton"  (click)="isReceivedQuantity ? null : addShortages()" [ngStyle]="{ 'background-color' : (isReceivedQuantity) ? '#ccc' : '#881952' }">
                    <div class="label">Add Received Quantity</div>
                </div>
            </div>
        </div>
    </div>
</div>